"use strict";
window.theme = window.theme || {}
theme.productCtaProfiling = function() {
    function productCtaProfiling() {
        this.add_to_cart = {
            btn_collection_page: document.querySelectorAll('.collection-add-to-cart'),
            btn_homepage_slider: document.querySelectorAll('.featured-collection-add-to-cart'),
            btn_product_page: document.querySelectorAll('.product-add-to-cart-cta .add-to-cart__button'),
            btn_sticky_header: document.querySelectorAll('.sticky-header-has-cta input.btn'),
            btn_sticket_add_to_cart: document.querySelectorAll('.sticky-add-to-cart')
        }
        this.contact_cta = {
            btn_product_page_conciergerie: document.querySelectorAll('.product__meta .js-contact-conciergerie'),
            btn_product_page_advisor: document.querySelectorAll('.product__meta .js-contact-advisor'),
            btn_sticky_header_conciergerie: document.querySelectorAll('.header__right .js-contact-conciergerie'),
            btn_sticky_header_advisor: document.querySelectorAll('.header__right .js-contact-advisor')
        }
        this.login_container = {
            login_status: document.querySelector('.js-login-status')
        }

        this.load();
    }

    productCtaProfiling.prototype.load = function() {
            var _ = this;
            let loginstatus = _.login_container.login_status.getAttribute('data-login-status') === 'true' ? true : false;
            let collection_page = _.add_to_cart.btn_collection_page;
            let homepage_slider = _.add_to_cart.btn_homepage_slider;
            let product_page = _.add_to_cart.btn_product_page;
            let product_conciergerie = _.contact_cta.btn_product_page_conciergerie;
            let product_advisor = _.contact_cta.btn_product_page_advisor;
            let sticky_header = _.add_to_cart.btn_sticky_header;
            let sticky_conciergerie = _.contact_cta.btn_sticky_header_conciergerie;
            let sticky_advisor = _.contact_cta.btn_sticky_header_advisor;
            let sticky_add_to_cart = _.add_to_cart.btn_sticket_add_to_cart;
            let enabled_cta_collection_page = _.login_container.login_status.getAttribute('data-enabled-cta-profiling-collection-page') === 'true' ? true : false;
            let collection_page_viewed = window.location.pathname.includes('collections') ? true : false;
            let enabled_cta_homeage_page = _.login_container.login_status.getAttribute('data-enabled-cta-profiling-homepage') === 'true' ? true : false;
            let enabled_cta_homepage_page = _.login_container.login_status.getAttribute('data-enabled-cta-profiling-homepage') === 'true' ? true : false;
            
            let homepage_page_viewed = window.location.pathname.includes('/') ? true : false;
            let enabled_cta_product_page = window.location.pathname.includes('products') ? true : false;
            let product_page_viewed = _.login_container.login_status.getAttribute('data-enabled-cta-profiling-product-page') === 'true' ? true : false;
            let membership_status = _.login_container.login_status.getAttribute('data-account-registered') === 'true' ? true : false;
            if (loginstatus && membership_status) {  
                if(collection_page_viewed && enabled_cta_collection_page) {
                    collection_page.forEach(e => {
                        let data_cta_registered = e.getAttribute('data-cta-registered') === 'true' ? true : false;
                        let data_product_availability = e.getAttribute('data-product-availability') === 'true' ? true : false; 
                        if(!data_cta_registered && !data_product_availability) {
                            e.classList.add('d-none');
                        } 
                        if(!data_cta_registered && data_product_availability) {
                            e.classList.add('d-none');
                        } 
                        if(data_cta_registered && !data_product_availability) {
                            e.classList.add('d-none');
                        } 
                        if(data_cta_registered && data_product_availability) {
                            e.classList.remove('d-none');
                        } else {
                            e.classList.add('d-none');
                        }
                    })
                }        
                if(homepage_page_viewed && enabled_cta_homepage_page) {
                    homepage_slider.forEach(e => {
                        let data_cta_registered = e.getAttribute('data-cta-registered') === 'true' ? true : false;
                        if(!data_cta_registered) {
                            e.style.setProperty('width','0');
                            e.style.setProperty('visibility','hidden');
                            e.style.setProperty('margin','1rem');
                        } else {
                            e.removeAttribute('style');
                        }
                    })
                }    
                if(product_page_viewed && enabled_cta_product_page) {
                        product_page.forEach(e => {
                            if (window.store_environment === 'louis-xiii-dev-uk' || 
                                window.store_environment === 'louis-xiii-staging-uk' || 
                                window.store_environment === 'louis-xiii-prod-uk') {
                                let data_cta_registered = e.getAttribute('data-cta-registered') === 'true' ? true : false;
                                let data_product_availability = e.getAttribute('data-cta-product-availability') === 'true' ? true : false; 
                                if(!data_cta_registered && !data_product_availability) {
                                    e.classList.add('d-none');
                                } 
                                if(data_cta_registered && !data_product_availability) {
                                    e.classList.add('d-none');
                                } 
                                if(!data_cta_registered && data_product_availability) {
                                    e.classList.add('d-none');
                                } 
                                if(data_cta_registered && data_product_availability) {
                                    e.classList.remove('d-none');
                                } 
                            } else {
                            e.classList.add("d-none");
                        }
                        
                    })

                    homepage_slider.forEach(e => {
                        let data_cta_registered = e.getAttribute('data-cta-registered') === 'true' ? true : false;
                        if(!data_cta_registered) {
                            e.style.setProperty('width','0');
                            e.style.setProperty('visibility','hidden');
                            e.style.setProperty('margin','1rem');
                        } else {
                            e.removeAttribute('style');
                        }
                    })

                    sticky_add_to_cart.forEach(e => {
                        let data_cta_registered = e.getAttribute('data-cta-registered') === 'true' ? true : false;
                        let data_product_availability = e.getAttribute('data-cta-product-availability') === 'true' ? true : false; 
                        if(!data_cta_registered && !data_product_availability) {
                            e.classList.add('d-none');
                        } 
                        if(!data_cta_registered && data_product_availability) {
                            e.classList.add('d-none');
                        } 
                        if(data_cta_registered && !data_product_availability) {
                            e.classList.add('d-none');
                        } 
                        if(data_cta_registered && data_product_availability) {
                            e.classList.remove('d-none');
                        } 
                    })                    
                    product_advisor.forEach(e => {
                        let data_cta_registered = e.getAttribute('data-cta-registered') === 'true' ? true : false;
                        let data_product_availability = e.getAttribute('data-cta-product-availability') === 'true' ? true : false; 
                        if(!data_cta_registered && !data_product_availability) {
                            e.classList.remove('d-none');
                        }
                        if(!data_cta_registered && !data_product_availability) {
                            e.classList.remove('d-none');
                        } 
                        if(!data_cta_registered && data_product_availability) {
                            e.classList.remove('d-none');
                        } 
                        if(data_cta_registered && !data_product_availability) {
                            e.classList.remove('d-none');
                        } 
                        if(!data_cta_registered && data_product_availability) {
                            e.classList.remove('d-none');
                        } 
                        if(data_cta_registered && data_product_availability) {
                            e.classList.add('d-none');                        
                        } 
                    })      
                    sticky_header.forEach(e => {
                        let data_cta_registered = e.getAttribute('data-cta-registered') === 'true' ? true : false;
                        let data_product_availability = e.getAttribute('data-cta-product-availability') === 'true' ? true : false; 
                        if(!data_cta_registered && !data_product_availability) {
                            e.classList.add('d-none');
                        } 
                        if(data_cta_registered && !data_product_availability) {
                            e.classList.add('d-none');
                        }
                        if(!data_cta_registered && data_product_availability) {
                            e.classList.add('d-none');
                        }
                        if(data_cta_registered && data_product_availability) {
                            e.classList.remove('d-none');                        
                        }
                    })                   
                    sticky_advisor.forEach(e => {
                        let data_cta_registered = e.getAttribute('data-cta-registered') === 'true' ? true : false;
                        let data_product_availability = e.getAttribute('data-cta-product-availability') === 'true' ? true : false; 
                        if(!data_cta_registered && !data_product_availability) {
                            e.classList.remove('d-none');
                        } 
                        if(!data_cta_registered && !data_product_availability) {
                            e.classList.remove('d-none');
                        }
                        if(!data_cta_registered && data_product_availability) {
                            e.classList.remove('d-none');
                        }
                        if(data_cta_registered && !data_product_availability) {
                            e.classList.remove('d-none');
                        }
                        if(!data_cta_registered && data_product_availability) {
                            e.classList.remove('d-none');
                        }
                        if(data_cta_registered && data_product_availability) {
                            e.classList.add('d-none');                        
                        } 
                    })                    
                }                 
            } else {
                if(collection_page_viewed && enabled_cta_collection_page) {
                    collection_page.forEach(e => {
                        let data_cta_unregistered = e.getAttribute('data-cta-unregistered') === 'true' ? true : false;
                        let data_product_availability = e.getAttribute('data-product-availability') === 'true' ? true : false; 
                        if(!data_cta_unregistered && !data_product_availability) {
                            e.classList.add('d-none');
                        } 
                        if(data_cta_unregistered && !data_product_availability) {
                            e.classList.add('d-none');
                        } 
                        if(!data_cta_unregistered && data_product_availability) {
                            e.classList.add('d-none');
                        } 
                        if(data_cta_unregistered && data_product_availability) {
                            e.classList.remove('d-none');
                        }
                    })
                }        
                if(homepage_page_viewed && enabled_cta_homepage_page) {
                    homepage_slider.forEach(e => {
                        let data_cta_unregistered = e.getAttribute('data-cta-unregistered') === 'true' ? true : false;
                        if(!data_cta_unregistered) {
                            e.style.setProperty('width','0');
                            e.style.setProperty('visibility','hidden');
                            e.style.setProperty('margin','1rem');
                        } else {
                            e.removeAttribute('style');
                        }
                    })
                }        
                if(product_page_viewed && enabled_cta_product_page) {

                    homepage_slider.forEach(e => {
                        let data_cta_registered = e.getAttribute('data-cta-registered') === 'true' ? true : false;
                        if(!data_cta_registered) {
                            e.style.setProperty('width','0');
                            e.style.setProperty('visibility','hidden');
                            e.style.setProperty('margin','1rem');
                        } else {
                            e.removeAttribute('style');
                        }
                    })

                    product_page.forEach(e => {
                        // The add to cart button will never show for editorial environments
                        if (window.store_environment === 'louis-xiii-dev-uk' || 
                            window.store_environment === 'louis-xiii-staging-uk' || 
                            window.store_environment === 'louis-xiii-prod-uk') {

                            let data_cta_unregistered = e.getAttribute('data-cta-unregistered') === 'true' ? true : false;
                            let data_product_availability = e.getAttribute('data-cta-product-availability') === 'true' ? true : false;
                            if(!data_cta_unregistered && !data_product_availability) {
                                e.classList.add('d-none');
                            } 
                            if(!data_cta_unregistered && !data_product_availability) {
                                e.classList.add('d-none');
                            } 
                            if(!data_cta_unregistered && data_product_availability) {
                                e.classList.add('d-none');
                            } 
                            if(!data_cta_unregistered && data_product_availability) {
                                e.classList.add('d-none');
                            } 
                            if(data_cta_unregistered && data_product_availability) {
                                e.classList.remove('d-none');                        
                            } else {
                                e.classList.add('d-none');
                            }
                        } else {
                            e.classList.add("d-none");
                        }
                    })
                    sticky_add_to_cart.forEach(e => {
                        let data_cta_unregistered = e.getAttribute('data-cta-unregistered') === 'true' ? true : false;
                        let data_product_availability = e.getAttribute('data-cta-product-availability') === 'true' ? true : false;
                        if(!data_cta_unregistered && !data_product_availability) {
                            e.classList.add('d-none');
                        } 
                        if(!data_cta_unregistered && data_product_availability) {
                            e.classList.add('d-none');
                        } 
                        if(data_cta_unregistered && data_product_availability) {
                            e.classList.remove('d-none');                        
                        } else {
                            e.classList.add('d-none');
                        }
                    })
                    product_conciergerie.forEach(e => {
                        // The contact conciergerie will not have profiling mechanism for editorial environments
                        if (window.store_environment === 'louis-xiii-dev-uk' || 
                            window.store_environment === 'louis-xiii-staging-uk' || 
                            window.store_environment === 'louis-xiii-prod-uk') {
                             
                            let data_cta_unregistered = e.getAttribute('data-cta-unregistered') === 'true' ? true : false;
                            let data_product_availability = e.getAttribute('data-cta-product-availability') === 'true' ? true : false;
                            if(!data_cta_unregistered && !data_product_availability) {
                                e.classList.remove('d-none');
                            } 
                            if(!data_cta_unregistered && data_product_availability) {
                                e.classList.remove('d-none');
                            }
                            if(data_cta_unregistered && !data_product_availability) {
                                e.classList.remove('d-none');
                            }
                            if(data_cta_unregistered && data_product_availability) {
                                e.classList.add('d-none');                        
                            } 
                        } else {
                            e.classList.remove("d-none");
                        
                        }
                    })  
                    sticky_header.forEach(e => {
                        let data_cta_unregistered = e.getAttribute('data-cta-unregistered') === 'true' ? true : false;
                        let data_product_availability = e.getAttribute('data-cta-product-availability') === 'true' ? true : false;
                        if(!data_cta_unregistered && !data_product_availability) {
                            e.classList.add('d-none');
                        } 
                        if(!data_cta_unregistered && !data_product_availability) {
                            e.classList.add('d-none');
                        }
                        if(data_cta_unregistered && !data_product_availability) {
                            e.classList.add('d-none');
                        }
                        if(!data_cta_unregistered && data_product_availability) {
                            e.classList.add('d-none');
                        }
                        if(!data_cta_unregistered && data_product_availability) {
                            e.classList.add('d-none');
                        }
                        if(data_cta_unregistered && data_product_availability) {
                            e.classList.remove('d-none');                        
                        }
                    })     
                    sticky_conciergerie.forEach(e => {
                        let data_cta_unregistered = e.getAttribute('data-cta-unregistered') === 'true' ? true : false;
                        let data_product_availability = e.getAttribute('data-cta-product-availability') === 'true' ? true : false;
                        if(!data_cta_unregistered && !data_product_availability) {
                            e.classList.remove('d-none');
                        } 
                        if(!data_cta_unregistered && data_product_availability) {
                            e.classList.remove('d-none');
                        }
                        if(data_cta_unregistered && !data_product_availability) {
                            e.classList.remove('d-none');
                        }
                        if(data_cta_unregistered && data_product_availability) {
                            e.classList.add('d-none');                        
                        } 
                    })                                  
                }                 
            }
    }

    theme.productCtaProfiling = new productCtaProfiling;

}

theme.productCtaProfiling();
